import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { request } from "../../../utils/Request";
import UrlHelper from "js-url-helper";
import AnalyticsVehicleReportList from "./partials/AnalyticsVehicleReportList";
import { Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
import { setToStorage } from "../../../utils/Helper";

const DEFAULT_DROPDOWNS = {
    routes: [],
    clients: [],
    legalEntities: [],
};

const url = new UrlHelper();

const AnalyticsVehicleReport = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [dropdowns, setDropdowns] = useState<any>(null);
    const [moduleState, setModuleState] = useState<any>({
        initialized: false,
    });

    const getDropdowns = async () => {
        try {
            const response = await request({
                url: '/suppliers/reports/vehicles/create',
                params: {
                    type: 'list',
                }
            });
            const { data } = response.data;
            setDropdowns(data);
        } catch (e) {
            setDropdowns(DEFAULT_DROPDOWNS);
        } finally {
            setModuleState({
                initialized: true
            });
        }
    };

    useEffect(() => {
        document.title = t("vehicle report");

        async function init() {
            await getDropdowns();
        }

        init();
    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    const setQuery = (value: any) => {
        setToStorage('supplierAnalyticsVehicleReportModuleState', JSON.stringify(value));
        setModuleState(value);
    }

    return (
        <div className={ "module-container" }>
            <Toast ref={toast} />
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <AnalyticsVehicleReportList
                                    moduleState={ moduleState }
                                    dropdowns={ dropdowns }
                                    toastify={ toastify }
                                    setQuery={ setQuery }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

// AnalyticsVehicleReport.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(AnalyticsVehicleReport);
